module.exports = __webpack_public_path__ + "img/cattunnel00.62d009f5.jpg";